module.exports = __webpack_public_path__ + "static/img/m_name.b5c8bb5.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/xk/m_name.png
// module id = JNj2
// module chunks = 7